import { useUpdateAgentStatus } from 'gcs-common/clients/api/entities/current-user/current-user-hooks';
import IconComponent from 'gcs-common/components/Icon/Icon';
import Spinner from 'gcs-common/components/Spinner/Spinner';
import { ICON, ICON_COLOR, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import { ONLINE_STATUS } from 'gcs-common/helper/userStatusHelper';
import {
  getCurrentUserImage,
  getCurrentUserStatus,
  getIsAgent,
} from 'gcs-common/slices/currentUser/currentUserSelectors';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import checkIcon from '../../img/check.svg';
import Button from '../Button/Button';
import ImageWithStatus from '../ImageWithStatus/ImageWithStatus';
import PopupMenu from '../PopupMenu/PopupMenu';
import styles from './styles.module.scss';

const CurrentUserImage = () => {
  const isAgent = useSelector(getIsAgent);
  const imageUrl = useSelector(getCurrentUserImage);
  const currentStatus = useSelector(getCurrentUserStatus);
  const [showMenu, setShowMenu] = useState(false);

  const { updateAgentStatus, isPending } = useUpdateAgentStatus();

  const setAgentStatus = (statusType: ONLINE_STATUS) => async () => {
    await updateAgentStatus({ statusType });
    setShowMenu(false);
  };

  const { type: currentStatusType } = currentStatus;

  if (!isAgent) {
    return <ImageWithStatus imageUrl={imageUrl} userStatus={currentStatus} />;
  }

  return (
    <div
      tabIndex={0}
      role="button"
      className={styles.button}
      onKeyUp={() => setShowMenu(true)}
      onClick={() => setShowMenu(true)}
      data-testid="current-user-image"
      data-teststatus={currentStatus.type}
    >
      <ImageWithStatus key="profile" imageUrl={imageUrl} userStatus={currentStatus} />
      <PopupMenu key="popup-menu" isVisible={showMenu} onHide={() => setShowMenu(!showMenu)}>
        <div className={styles.statusTitle}>
          <span>Status setzen</span>
          {isPending && <Spinner size={ICON_SIZE.X_SMALL} />}
        </div>
        <Button
          type="button"
          onClick={setAgentStatus(ONLINE_STATUS.ONLINE)}
          className={styles.status}
          data-testid="current-user-online-status-online"
          data-teststatus={currentStatusType === ONLINE_STATUS.ONLINE}
        >
          {currentStatusType === ONLINE_STATUS.ONLINE ? (
            <img alt="Ausgewählte Sortierart" src={checkIcon} />
          ) : (
            <img alt="" src={checkIcon} style={{ opacity: 0 }} />
          )}
          <IconComponent
            Icon={ICON.ECLIPSE}
            size={ICON_SIZE.XXX_SMALL}
            color={ICON_COLOR.SUCCESS}
            style={{ marginRight: '12px' }}
          />
          Aktiv
        </Button>
        <Button
          type="button"
          onClick={setAgentStatus(ONLINE_STATUS.IDLE)}
          className={styles.status}
          data-testid="current-user-online-status-idle"
          data-teststatus={currentStatusType === ONLINE_STATUS.IDLE}
        >
          {currentStatusType === ONLINE_STATUS.IDLE ? (
            <img alt="Ausgewählte Sortierart" src={checkIcon} />
          ) : (
            <img alt="" src={checkIcon} style={{ opacity: 0 }} />
          )}
          <IconComponent
            Icon={ICON.ECLIPSE}
            size={ICON_SIZE.XXX_SMALL}
            color={ICON_COLOR.WARNING}
            style={{ marginRight: '12px' }}
          />
          <div className={styles.nowrap}>In Kürze verfügbar</div>
        </Button>
        <Button
          type="button"
          onClick={setAgentStatus(ONLINE_STATUS.OFFLINE)}
          className={styles.status}
          data-testid="current-user-online-status-offline"
          data-teststatus={currentStatusType === ONLINE_STATUS.OFFLINE}
        >
          {currentStatusType === ONLINE_STATUS.OFFLINE ? (
            <img alt="Ausgewählte Sortierart" src={checkIcon} />
          ) : (
            <img alt="" src={checkIcon} style={{ opacity: 0 }} />
          )}
          <IconComponent
            Icon={ICON.ECLIPSE}
            size={ICON_SIZE.XXX_SMALL}
            color={ICON_COLOR.ERROR}
            style={{ marginRight: '12px' }}
          />
          Inaktiv
        </Button>
      </PopupMenu>
    </div>
  );
};
export default CurrentUserImage;
